import { render, staticRenderFns } from "./merged_posts.vue?vue&type=template&id=71426df0&scoped=true&"
import script from "./merged_posts.vue?vue&type=script&lang=js&"
export * from "./merged_posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71426df0",
  null
  
)

export default component.exports